import styled from 'styled-components';

export const TitelText = styled.p`
  color: ${(p) => (p.Titel === 'titel' ? p.theme.colors.accent.primary : p.theme.colors.primary.black)};
  font-weight: ${(p) => (p.Titel === 'titel' ? '700' : '500')};
  font-size: ${(p) => (p.Titel === 'titel' ? '21px' : '14px')};
  text-align: ${(p) => (p.Titel === 'titel' ? 'center' : 'left')};
`;

export const InputPassword = styled.span`
  border: ${(p) => `2px solid ${p.error ? p.theme.colors.status.cherryRed : p.theme.colors.accent.primary}`};
  display: flex;
  align-items: center;
  background-color:${(p) => p.theme.colors.primary.white} !important;
  width: 400px;
`;

export const ContainerChangePassword = styled.div`
  background-color: ${(p) => p.theme.colors.primary.white};
  width: 700px;
  border-radius: 1.5em;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  min-height: 257px;
  padding: 2em 2em;
`;

export const ChangePasswordWrapper = styled.div`
  height: 100vh;
  width: 100%;
  background-image: ${(p) => `url(${p.theme.config.changePasswordBg})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: fixed;
  position: fixed;
  z-index: 50002;

  .changePassword-wrapper{
  background-image: ${(p) => `linear-gradient(
    ${`${p.theme.colors.accent.primary}BF`}
     20%,
     ${`${p.theme.colors.accent.primary}B3`}
      )`};
  height: 100vh;
  width: 100%;
  overflow: auto
}
.container-wrapper{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 4em 0;

}
.containerChangePassword {
  background-color: ${(p) => p.theme.colors.primary.white};
  width: 700px;
  border-radius: 1.5em;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  min-height: 257px;
  padding: 2em 2em;
}
.titelTexts, .input-Wrapper{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 2em;
}
.errorMessageLabel {
  text-align: right;
  color: red;
  font-weight: 600;
  margin-top: -12px;
  margin-bottom: 7px;
}

.enelLogo{
  display: flex;
  justify-content: center;
  padding-top: 5em;
}
.backsign{
  font-size: 20px;
  margin-left: 10%;
  margin-top: -2em;
  cursor: pointer;
  color: ${(p) => p.theme.colors.primary.white};
  display: flex;
  align-items: center;
  width: 100px;
}
.backsign span:nth-child(1){
  font-size: 25px;
  font-weight: bold;
  margin-right: 1em;
}

#icon-back:before{
  color: ${(p) => `${p.theme.colors.primary.white} !important`};
}
.PasswordEye {
font-size: 1.5rem;
color: ${(p) => p.theme.colors.primary.darkGrey};
margin-right:0.5rem;
  cursor: pointer;
}

.input-password{
display: flex;
align-items: center;
background-color: ${(p) => `${p.theme.colors.primary.white} !important`};
  border: ${(p) => `2px solid ${p.theme.colors.primary.grey}`}
  width: 400px;
}
.password{
border: none !important;
}
.password:focus, #email:focus{
border: none !important;
outline: 0 none !important;
box-shadow: none !important;
}

.logo-enel{
  font-size: 60px;
  color: ${(p) => p.theme.colors.primary.white};
}
.confirm-btn{
  margin-top: 2em;
  margin-left: 8em;
  padding-bottom: 1em;
}

.error-wrapper{
  margin: 0 auto;
  width: 100%;
  
}
.closeIcon{
  font-size: 4em;
  text-align: center;
  margin-top: 40px;
}
.ok-btn{
  padding-top: 10px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
}
.error-subtext{
  margin-top: 3em;
  margin-bottom: 2em;
}
.form-control {
  background-color: ${(p) => p.theme.colors.primary.white}
}

`;
